import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import { useSelector, useDispatch } from 'react-redux'
import { Dialog } from '@mui/material'

import { setTotalSteps, reset } from '@/redux/ducks/wizard/config'
import { CreateClientProvider } from './context'

import Connection from './connection'
import ContactPerson from './contact-person'
import Company from './company'
import { CONNECTION_TYPE_ONLINE } from '@/modules/client/constants'

const CreateModal = ({ onClose, open, invitationMode, clientData }) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const handleClose = () => {
    dispatch(reset())
    updateSteps(CONNECTION_TYPE_ONLINE)
    onClose && onClose()
  }

  const [steps, setSteps] = useState([])
  const { step } = useSelector(state => state.wizard.config)

  const updateSteps = (connectionType) => {
    const stepsToRender = connectionType === CONNECTION_TYPE_ONLINE ? onlineSteps : offlineSteps
    setSteps(stepsToRender)
  }

  const onlineSteps = [
    <Connection onClose={handleClose} updateSteps={updateSteps} invitationMode={invitationMode} />,
    <ContactPerson />,
    <Company clientData={clientData} onClose={handleClose} />,
  ]

  const offlineSteps = [
    <Connection onClose={handleClose} updateSteps={updateSteps} />,
    <Company onClose={handleClose} />,
  ]

  useEffect(() => {
    if (steps.length > 1) {
      dispatch(setTotalSteps(steps.length - 1))
    }
  }, [steps])

  useEffect(() => {
    updateSteps(CONNECTION_TYPE_ONLINE)
  }, [])

  useEffect(() => {
    if (open) {
      dispatch(reset())
      dispatch(setTotalSteps(steps.length - 1))
    }
  }, [open])

  return (
    <Dialog
      maxWidth={false}
      scroll="paper"
      open={open}
      onClose={handleClose}
      classes={{
        paper: classes.paper,
      }}
    >
      <CreateClientProvider clientData={clientData}>
        <div className={classes.container}>
          {steps[step]}
        </div>
      </CreateClientProvider>
    </Dialog>
  )
}

const useStyles = makeStyles(() => ({
  paper: ({ isMbo }) => ({
    width: '100%',
    height: '100%',
    margin: 0,
    maxHeight: '100%',
    maxWidth: '100%',
    [`@media (min-width: ${isMbo ? '800' : '1034'}px)`]: {
      width: isMbo ? 790 : 900,
      height: isMbo ? 565 : 690,
    },
  }),
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    '@media (max-width: 900px)': {
      overflowY: 'auto',
    },
  },
}))

CreateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  invitationMode: PropTypes.bool,
  clientData: PropTypes.object,
}

CreateModal.defaultProps = {
  open: false,
  invitationMode: false,
  clientData: null,
}

export default CreateModal
